import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { QuantityStepperComponent } from '../quantity-stepper/quantity-stepper.component';

/**
 * Price tag row inside a choice card: label, price and notes (projected) + quantity stepper.
 * Projected slots: [rowLabel], [rowPrice], [rowNote] (one element per note).
 */
@Component({
  selector: 'app-price-row',
  templateUrl: './price-row.component.html',
  styleUrls: ['./price-row.component.scss'],
  standalone: true,
  imports: [QuantityStepperComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriceRowComponent {
  @Input() quantity: number = 0;
  // No stepper (e.g. sold out ticket type)
  @Input() locked: boolean = false;
  @Output() decrement = new EventEmitter<void>();
  @Output() increment = new EventEmitter<void>();
}
